document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  const closeMenu = () => {
    if (!menuToggle || !mobileMenu) return;
    menuToggle.setAttribute('aria-expanded', 'false');
    mobileMenu.classList.remove('is-open');
    document.body.classList.remove('menu-open');
  };

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const opening = menuToggle.getAttribute('aria-expanded') !== 'true';
      menuToggle.setAttribute('aria-expanded', String(opening));
      mobileMenu.classList.toggle('is-open', opening);
      document.body.classList.toggle('menu-open', opening);
    });

    mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  }

  document.querySelectorAll('[data-personalizer]').forEach((personalizer) => {
    const toggle = personalizer.querySelector('[data-branding-toggle]');
    const fields = personalizer.querySelector('[data-branding-fields]');
    const requiredInput = personalizer.querySelector('[data-branding-required]');
    if (!toggle || !fields) return;

    const syncPersonalizer = () => {
      fields.hidden = !toggle.checked;
      if (requiredInput) requiredInput.required = toggle.checked;
    };

    toggle.addEventListener('change', syncPersonalizer);
    syncPersonalizer();
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = option.dataset.price;
      const displayPrice = document.querySelector('[data-product-price]');
      const buttonPrice = document.querySelector('[data-button-price]');
      if (price && displayPrice) displayPrice.textContent = price;
      if (price && buttonPrice) buttonPrice.textContent = price;
    });
  });

  const filterPanel = document.querySelector('[data-filter-panel]');
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterClose = document.querySelector('[data-filter-close]');

  const closeFilters = () => {
    if (filterPanel) filterPanel.hidden = true;
  };

  if (filterPanel && filterToggle) {
    filterToggle.addEventListener('click', () => {
      filterPanel.hidden = false;
      const firstControl = filterPanel.querySelector('button, input, select');
      if (firstControl) firstControl.focus();
    });
  }

  if (filterClose) filterClose.addEventListener('click', closeFilters);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenu();
      closeFilters();
    }
  });
});

